// REISOR_P19_NATIVE_PUBLIC_ASSET_URL_V1
// API JSON may intentionally return same-origin /api/* URLs for web.
// Capacitor/localhost must resolve those assets against the production backend.
const REMOTE_API_ORIGIN = String(
  import.meta.env.VITE_BACKEND_ORIGIN || "https://backend.cargo-platform.online"
).replace(/\/+$/, "");

export function isReisorNativeLocalRuntime() {
  try {
    const protocol = String(window?.location?.protocol || "").toLowerCase();
    const host = String(window?.location?.hostname || "").toLowerCase();
    return (
      protocol === "capacitor:" ||
      protocol === "file:" ||
      host === "localhost" ||
      host === "127.0.0.1"
    );
  } catch {
    return false;
  }
}

export function resolveReisorPublicAssetUrl(value) {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^(https?:|data:|blob:)/i.test(raw)) return raw;

  let path = raw;
  if (path.startsWith("/uploads/")) path = `/api${path}`;

  if (path.startsWith("/api/") && isReisorNativeLocalRuntime()) {
    return `${REMOTE_API_ORIGIN}${path}`;
  }

  return path;
}
